import type { HTMLAttributes, ReactNode } from 'react';
import './Card.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Interactive cards get hover and focus affordances; pass an onClick or wrap in a link. */
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: ReactNode;
}

export function Card({
  interactive,
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps): ReactNode {
  const classes = [
    'pui-card',
    `pui-card--pad-${padding}`,
    interactive && 'pui-card--interactive',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): ReactNode {
  return (
    <div className={['pui-card__header', className].filter(Boolean).join(' ')}>{children}</div>
  );
}

export function CardTitle({ children }: { children: ReactNode }): ReactNode {
  return <h3 className="pui-card__title">{children}</h3>;
}
